import { useSLA } from '@/features/SLAs/useSLA'
import { useNavigate } from 'react-router-dom'
import SLAForm from '../components/SLAForm'

const AddSLA = () => {
  const newSLA = {
    templateName: '',
    questionnaire: {},
  }
  const { useCreateSLA } = useSLA()

  const createSLA = useCreateSLA()
  const navigate = useNavigate()

  const onSubmit = async (data) => {
    console.log('In Add SLA Page: ', data)
    createSLA.mutate(data, {
      onSuccess: () => {
        navigate('/admin/SLAs/')
      },
    })
  }

  return <SLAForm onSubmitAction={onSubmit} SLA={newSLA} />
}

export default AddSLA
